module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/tactical-training-elite-reward-50.263bd908.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/tactical-training-elite-reward-50.png
// module id = 3799
// module chunks = 11